import { useEffect, useState } from "react";
import { faqList } from "@/mocks/melon";
import TopNav from "./components/TopNav";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Breaking from "./components/Breaking";
import Reviews from "./components/Reviews";
import Dict from "./components/Dict";
import Category from "./components/Category";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

function JsonLd() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  const siteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "瓜田日报 · 全网热榜资讯站",
    inLanguage: "zh-CN",
    description: "汇集全网热门事件与突发大事，提供热榜、突发跟进与深度复盘的吃瓜资讯门户。",
  };
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-900">
      <JsonLd />
      <TopNav />
      <Ticker />
      <main>
        <Hero />
        <HotRank />
        <Breaking />
        <Reviews />
        <Dict />
        <Category />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}